export default __webpack_public_path__ + "static/cues-starters-light-c8e53cb4d4bcbe6907e79fee18453320.png";